import LanguageDetector from 'i18next-browser-languagedetector'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from '@/lang/en.json';
import cn from '@/lang/cn.json';
import es from '@/lang/es.json';
import id from '@/lang/id.json';
import pt from '@/lang/pt.json';
import tc from '@/lang/tc.json';
import th from '@/lang/th.json';

let resources = {
  en: {
    translation: en,
  },
  cn: {
    translation: cn,
  },
  es: {
    translation: es,
  },
  id: {
    translation: id,
  },
  pt: {
    translation: pt,
  },
  tc: {
    translation: tc,
  },
  th: {
    translation: th,
  },
}

i18n
  .use(LanguageDetector) // 嗅探当前浏览器语言
  .use(initReactI18next) // init i18next
  .init({
    // 引入资源文件
    resources,
    // 选择默认语言，选择内容为上述配置中的key，即en/zh
    fallbackLng: 'cn',
    lng: localStorage.getItem('i18nextLng') || 'cn',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
    },
  })

export default i18n
